module.exports = __webpack_public_path__ + "img/v4plus.67da8d6c.svg";